import continents from 'app/config/continents';

const getContinentByCountry = (countryCode: string) => continents[countryCode.toUpperCase()];

export { getContinentByCountry };
